<template>
    <CContainer>
      <CRow>
        <CCol col="12" sm="6" class="d-flex overflow-auto px-0 mx-auto">
          <!-- <FilterIt class="mfe-2" /> -->
          <!-- <SortIt class="min-w-fit-content mr-auto" /> -->
        </CCol>
      </CRow>

      <Table class="mt-2" />
    </CContainer>
  </template>

  <script>
  import { Table, FilterIt, SortIt } from './partials'

  export default {
    name: 'List',

    components: {
      FilterIt,
      SortIt,
      Table,
    },
  }
  </script>
